package one.healthium.url_provider.data.api

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.http.GET
import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig
import io.ktor.client.plugins.HttpResponseValidator
import io.ktor.client.plugins.ResponseException
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.logging.LogLevel
import io.ktor.client.plugins.logging.Logger
import io.ktor.client.plugins.logging.Logging
import io.ktor.http.HttpStatusCode
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import one.healthium.url_provider.data.dto.UrlItemDto
import one.primehealth.app.BaseUrls

internal interface UrlProviderApiClient {
    @GET("legal_product.json")
    suspend fun getLegalUrls(): List<UrlItemDto>

    companion object {
        fun factory(baseHttpClient: HttpClient, baseUrls: BaseUrls): UrlProviderApiClient {
            val ktorfit = Ktorfit.Builder()
                .httpClient(baseHttpClient)
                .baseUrl(baseUrls.content)
                .build()
            return ktorfit.createUrlProviderApiClient()
        }

        // TODO move to common modules
        fun createBaseHttpClient(
            json: Json,
            block: HttpClientConfig<*>.() -> Unit = {},
        ) =
            HttpClient {
                expectSuccess = true
                HttpResponseValidator {
                    handleResponseExceptionWithRequest { cause, _ ->
                        val clientException = cause as? ResponseException ?: return@handleResponseExceptionWithRequest
                        val exceptionResponse = clientException.response
                        if (exceptionResponse.status == HttpStatusCode.NotFound) {
                            throw Exception("Content not found")
                        }
                        throw Exception("Something went wrong")
                    }
                }
                install(Logging) {
                    logger = object : Logger {
                        override fun log(message: String) {
                            co.touchlab.kermit.Logger.d(tag = "HTTP", messageString = message)
                        }
                    }
                    level = LogLevel.ALL
                }
                install(ContentNegotiation) {
                    json(json)
                }

                block()
            }

    }
}